import React from "react";
import Layout from "../hoc/Layout";

function NotFound() {
  return (
    <Layout>
      <h1 style={{ textAlign: "center" }}>404 Error</h1>
      <h2 style={{ textAlign: "center" }}>Page is not here</h2>
    </Layout>
  );
}

export default NotFound;
